import CrossLink from './CrossLink';

export { type CrossLinkProps } from './CrossLink';
export default CrossLink;
